import { Link } from "react-router-dom";
import ScrollReveal from "@/components/ScrollReveal";

export default function AboutSnapshot() {
  return (
    <section data-testid="about-snapshot" className="relative bg-cloud py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0 grid-bg opacity-25 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <ScrollReveal className="lg:col-span-7">
          <div className="text-xs tracking-[0.22em] uppercase text-teal font-semibold">About RenVia</div>
          <h2 className="mt-5 font-display text-4xl md:text-5xl text-slate1 leading-tight">
            Built to help physicians access the next era of <span className="text-gradient-teal">regenerative ophthalmology</span>.
          </h2>
          <p className="mt-8 text-lg text-slate1/65 leading-relaxed max-w-2xl">
            RenVia was created to help eye care professionals access innovative regenerative
            technologies that improve outcomes and elevate patient care. As a trusted U.S.
            commercialization partner for Oculus Biologics and the XcellerEYES product line,
            we sit at the intersection of regenerative science and clinical practice.
          </p>
          <div className="mt-10 flex gap-4 flex-wrap">
            <Link
              to="/about"
              data-testid="about-cta-story"
              className="inline-flex items-center gap-2 rounded-full bg-navy text-white px-7 py-3.5 text-sm font-semibold hover:bg-teal transition-colors"
            >
              Read our story
              <span aria-hidden>→</span>
            </Link>
            <Link
              to="/resources"
              data-testid="about-cta-resources"
              className="inline-flex items-center gap-2 rounded-full border border-slate1/15 text-slate1 px-7 py-3.5 text-sm font-semibold hover:border-teal hover:text-teal transition-colors"
            >
              Clinical resources
            </Link>
          </div>
        </ScrollReveal>

        <ScrollReveal delay={140} className="lg:col-span-5">
          <div className="relative aspect-square rounded-3xl overflow-hidden hero-radial noise">
            <div className="absolute inset-0 grid-bg opacity-30" />
            <img
              src="/brand/renvia-icon-transparent.png"
              alt="RenVia mark"
              className="absolute inset-0 m-auto w-2/3 h-2/3 object-contain animate-floaty"
            />
            <div className="absolute bottom-8 left-8 right-8 text-white">
              <div className="text-[10px] tracking-[0.22em] uppercase text-teal2 font-bold">Trusted Partner</div>
              <div className="font-display text-xl font-medium mt-2">
                U.S. commercialization for Oculus Biologics & XcellerEYES.
              </div>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}
